import {
  RECRUITER_DETAIL_SET,
  RECRUITER_DETAIL_SET_SUCCESS,
  RECRUITER_DETAIL_SET_ERROR,
  RECRUITER_DETAIL_GET_COUNTRY,
  RECRUITER_DETAIL_GET_COUNTRY_SUCCESSFULL,
  RECRUITER_DETAIL_GET_COUNTRY_FAILED,
  RECRUITER_DETAIL_GET_STATE,
  RECRUITER_DETAIL_GET_STATE_SUCCESSFULL,
  RECRUITER_DETAIL_GET_STATE_FAILED,
  RECRUITER_DETAIL_GET_IP_LOCATION,
  RECRUITER_DETAIL_GET_IP_LOCATION_SUCCESSFULL,
  RECRUITER_DETAIL_GET_IP_LOCATION_FAILED,
  RECRUITER_PROFILE_ERROR, 
  RECRUITER_PROFILE_SUCCESS, 
  RECRUITER_EDIT_PROFILE, 
  RECRUITER_RESET_PROFILE_FLAG ,
  RECRUITER_GET_PROFILE_DETAIL,
  RECRUITER_GET_PROFILE_DETAIL_SUCCESS,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  setDetailError: null,
  setCountryData: null,
  setCountryDataError: null,
  setStatesData:null,
  setStatesDataError:null,
  setIplocation:null,
  setIplocationError:null,
  loading:false,
  success:null
}

const RecuriterDetailSet = (state = initialState, action) => {
  switch (action.type) {
    case RECRUITER_DETAIL_SET:
      state = {
        ...state,
        detailSetSuccess: null,
        setDetailError: null,
        loading:true
      }
      break
    case RECRUITER_DETAIL_SET_SUCCESS:
      state = {
        ...state,
        detailSetSuccess: action.payload,
        loading:false
      }
      break
    case RECRUITER_DETAIL_SET_ERROR:
      state = { ...state, setDetailError: action.payload ,loading:false}
      break

    case RECRUITER_DETAIL_GET_COUNTRY:
      state = {
        ...state,
        setCountryData: null,
        setCountryDataError: null,
        loading:true
      }
      break
    case RECRUITER_DETAIL_GET_COUNTRY_SUCCESSFULL:
      state = {
        ...state,
        setCountryData: action.payload,
        loading:false
      }
      break
    case RECRUITER_DETAIL_GET_COUNTRY_FAILED:
      state = {
        ...state,
        setCountryDataError: action.payload,
        loading:false
      }
      break

      case RECRUITER_DETAIL_GET_STATE:
      state = {
        ...state,
        setStatesData: null,
        setStatesDataError: null,
        loading:true
      }
      break
    case RECRUITER_DETAIL_GET_STATE_SUCCESSFULL:
      state = {
        ...state,
        setStatesData: action.payload,
        loading:false
      }
      break
    case RECRUITER_DETAIL_GET_STATE_FAILED:
      state = {
        ...state,
        setStatesDataError: action.payload,
        loading:false
      }
      break

      case RECRUITER_DETAIL_GET_IP_LOCATION:
      state = {
        ...state,
        setIplocation: null,
        setIplocationError: null,
        loading:true
      }
      break
    case RECRUITER_DETAIL_GET_IP_LOCATION_SUCCESSFULL:
      state = {
        ...state,
        setIplocation: action.payload,
        loading:false
      }
      break
    case RECRUITER_DETAIL_GET_IP_LOCATION_FAILED:
      state = {
        ...state,
        setIplocationError: action.payload,
        loading:false
      }
      break
      case RECRUITER_EDIT_PROFILE:
      state = { ...state ,loading: true}
      break
      case RECRUITER_GET_PROFILE_DETAIL:
      state={...state,
        loading: true}
      break
      case RECRUITER_GET_PROFILE_DETAIL_SUCCESS:
        state={...state,
          loading: false,
          success:action.payload}
        break;
    case RECRUITER_PROFILE_SUCCESS:
      state = { ...state, 
        loading: false,
        success: action.payload }
      break
    case RECRUITER_PROFILE_ERROR:
      state = { ...state, 
        loading: false,
        error: action.payload }
      break
    case RECRUITER_RESET_PROFILE_FLAG :
      state = { ...state,
        loading: false,
         success: null }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default RecuriterDetailSet
